import { Box, Typography } from '@mui/material';
import useStyles, { Button } from '../index.styles';

import FilterDropdown from './dropdown';
import SearchInput from './searchInput';
import MultiDropdown from './multiDropdown';

import {
  channelFilter,
  directionFilter,
  processModuleFilter,
  statusFilter,
  timeFilter,
} from './data';
import { DateType } from '..';
import SenderSearch from './senderSearch';

const LogFilter = ({
  selectedFilters,
  setSelectedFilters,
  onApply,
  dates,
  setDates,
}: {
  selectedFilters: any;
  setSelectedFilters: (x: any) => void;
  onApply: () => void;
  dates: DateType;
  setDates: (date: DateType) => void;
}) => {
  const classes = useStyles();

  const onFilterChange = (filterKey: string, value: any) => {
    let newFilter = { ...selectedFilters };
    if (newFilter.hasOwnProperty(filterKey)) {
      newFilter[filterKey] = value;
    }
    setSelectedFilters(newFilter);
  };

  return (
    <Box className={classes.filterLogCont}>
      <Box className={classes.filterGrid}>
        <Box sx={{ position: 'relative' }}>
          <FilterDropdown
            label='Time Period'
            filterKey='days'
            options={timeFilter}
            selectedValue={selectedFilters.days}
            onChange={onFilterChange}
            dates={dates}
            setDates={setDates}
          />
          {/* <Box
            sx={{
              position: 'absolute',
            }}
          >
            calendar
          </Box> */}
        </Box>
        <MultiDropdown
          filterKey='custom_modules'
          label='Process Module'
          options={processModuleFilter}
          selectedValue={selectedFilters.custom_modules}
          onChange={onFilterChange}
        />
        <MultiDropdown
          filterKey='direction'
          label='Direction'
          options={directionFilter}
          selectedValue={selectedFilters.direction}
          onChange={onFilterChange}
        />
        <MultiDropdown
          filterKey='custom_channels'
          label='Channel'
          options={channelFilter}
          selectedValue={selectedFilters.custom_channels}
          onChange={onFilterChange}
        />
        <MultiDropdown
          filterKey='status'
          label='Status'
          options={statusFilter}
          selectedValue={selectedFilters.status}
          onChange={onFilterChange}
        />
        {/* <SearchInput
          filterKey='sender_name'
          label='From'
          placeholder='Sender'
          searchValue={selectedFilters.sender_name}
          onSearch={onFilterChange}
        /> */}
        <SenderSearch
          label='From'
          senderName='sender_name'
          senderValue={selectedFilters.sender_name}
          senderModuleName='sender_module'
          senderModuleValue={selectedFilters.sender_module}
          onSearch={onFilterChange}
        />
        <SearchInput
          filterKey='receiver'
          label='To'
          placeholder='Receiver'
          searchValue={selectedFilters.receiver}
          onSearch={onFilterChange}
        />
      </Box>

      <Button onClick={onApply}>
        <Typography>Apply</Typography>
      </Button>
    </Box>
  );
};
export default LogFilter;
